"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextTools = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _get = _interopRequireDefault(require("lodash/get"));
var _ToolboxRow = _interopRequireDefault(require("../Toolbox/ToolboxRow"));
var _TextEditor = _interopRequireDefault(require("../TextEditor/TextEditor"));
var _TextEditorStateProvider = require("../TextEditor/TextEditorStateProvider");
var _ColorPalette = _interopRequireDefault(require("./ColorPalette"));
var _Canvas = require("../../CanvasInterface/Canvas");
var _styles = _interopRequireDefault(require("./styles"));
var _StyleParams = require("../../CanvasAdapters/PaperJs/Utils/StyleParams");
var _String = require("../../Utils/String");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var fontFamilyList = [{
  name: 'Arial',
  value: 'Arial, Helvetica, sans-serif'
}, {
  name: 'Comic Sans',
  value: '"Comic Sans MS", cursive, sans-serif'
}, {
  name: 'Impact',
  value: 'Impact, Charcoal, sans-serif'
}, {
  name: 'Monospace',
  value: '"Courier New", Courier, monospace'
}];
var fontSizeList = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
var TextTools = exports.TextTools = /*#__PURE__*/function (_React$Component) {
  _inherits(TextTools, _React$Component);
  var _super = _createSuper(TextTools);
  function TextTools() {
    var _this;
    _classCallCheck(this, TextTools);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "rteRef", _this.props.rteRef || /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "handleCommand", function (evt, value) {
      evt.preventDefault();
      _this.props.textEditorState.formatDoc(evt.target.value, value);
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeHTML", function (htmlElement) {
      var _assertThisInitialize = _assertThisInitialized(_this),
        selectedObject = _assertThisInitialize.props.canvas.selectedObject;
      if (selectedObject) {
        selectedObject.contentHTML = htmlElement;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeProp", function (prop, value) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        selectedObject = _assertThisInitialize2.props.canvas.selectedObject;
      if (selectedObject) {
        selectedObject[prop] = value;
      }
      var _this$props$textEdito = _this.props.textEditorState,
        currentStyle = _this$props$textEdito.currentStyle,
        updateCurrentStyle = _this$props$textEdito.updateCurrentStyle;
      updateCurrentStyle(_objectSpread(_objectSpread({}, currentStyle), {}, _defineProperty({}, prop, value)));
    });
    _defineProperty(_assertThisInitialized(_this), "renderLineTools", function (renderObj) {
      var renderLineTools = _this.props.renderLineTools;
      if (renderLineTools) {
        return renderLineTools(renderObj);
      }
      // render default
      var handleCommand = renderObj.handleCommand,
        ToolboxRow = renderObj.components.ToolboxRow;
      return /*#__PURE__*/_react["default"].createElement(ToolboxRow, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        value: "justifyLeft",
        onMouseDown: handleCommand
      }, "Left"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        value: "justifyCenter",
        onMouseDown: handleCommand
      }, "Center"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        value: "justifyRight",
        onMouseDown: handleCommand
      }, "Right"));
    });
    _defineProperty(_assertThisInitialized(_this), "renderInlineTools", function (renderObj) {
      var renderInlineTools = _this.props.renderInlineTools;
      if (!renderObj.textEditorState) {
        return null;
      }
      if (renderInlineTools) {
        return renderInlineTools(renderObj);
      }
      // render default
      var handleCommand = renderObj.handleCommand,
        ToolboxRow = renderObj.components.ToolboxRow,
        renderColorPalette = renderObj.renderColorPalette,
        fontFamilyList = renderObj.fontFamilyList,
        textEditorState = renderObj.textEditorState,
        selectedObject = renderObj.selectedObject;
      var formatDoc = textEditorState.formatDoc;
      var _textEditorState$getS = textEditorState.getStyleValues(),
        isBold = _textEditorState$getS.isBold,
        isItalic = _textEditorState$getS.isItalic,
        fontFamily = _textEditorState$getS.fontFamily,
        fontSize = _textEditorState$getS.fontSize;
      var fontSizeMin = selectedObject.fontSizeMin;
      return /*#__PURE__*/_react["default"].createElement(ToolboxRow, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        value: "bold",
        onMouseDown: handleCommand,
        style: {
          borderColor: isBold ? 'cyan' : ''
        }
      }, "Bold"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        value: "italic",
        onMouseDown: handleCommand,
        style: {
          borderColor: isItalic ? 'cyan' : ''
        }
      }, "Italic"), /*#__PURE__*/_react["default"].createElement("input", {
        placeholder: "Font size",
        value: parseInt(fontSize) || 16,
        min: fontSizeMin,
        onChange: function onChange(evt) {
          return formatDoc('fontSize', "".concat(evt.target.value, "px"));
        },
        type: "number"
      }), /*#__PURE__*/_react["default"].createElement("select", {
        onChange: function onChange(evt) {
          return formatDoc('fontFamily', evt.target.value);
        }
      }, fontFamilyList.map(function (font, i) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          selected: font.value === fontFamily,
          key: i,
          value: font.value,
          style: {
            fontFamily: font.value
          }
        }, font.name);
      })), renderColorPalette(renderObj));
    });
    _defineProperty(_assertThisInitialized(_this), "renderColorPalette", function (renderObj) {
      var _this$props = _this.props,
        textEditorState = _this$props.textEditorState,
        renderColorPalette = _this$props.renderColorPalette;
      if (renderColorPalette) {
        return renderColorPalette(renderObj);
      }
      // render default
      var ColorPalette = renderObj.components.ColorPalette;
      return /*#__PURE__*/_react["default"].createElement(ColorPalette, {
        onChange: function onChange(evt, color) {
          return textEditorState.formatDoc('foreColor', color);
        },
        value: textEditorState.currentStyle.color
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderTextEditor", function (renderObj) {
      var classes = renderObj.classes,
        rteRef = renderObj.rteRef,
        editorRef = renderObj.editorRef,
        selectedObject = renderObj.selectedObject,
        onChangeHTML = renderObj.onChangeHTML,
        onChangeProp = renderObj.onChangeProp,
        fullTextCommandList = renderObj.fullTextCommandList,
        autoFocusWhenMounted = renderObj.autoFocusWhenMounted,
        canvas = renderObj.canvas,
        textEditorElementProps = renderObj.textEditorElementProps,
        disableLinebreaks = renderObj.disableLinebreaks;
      var selectedCanvasObject = canvas.selectedObject;
      var explicitStyleParams = selectedCanvasObject ? selectedCanvasObject.getExplicitStyleParams() : {};
      var renderTextEditor = _this.props.renderTextEditor;
      if (renderTextEditor) {
        return renderTextEditor(_objectSpread(_objectSpread({}, renderObj), {}, {
          explicitStyleParams: explicitStyleParams,
          components: {
            TextEditor: _TextEditor["default"]
          }
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_TextEditor["default"], {
        className: classes.textEditorContent,
        ref: editorRef,
        rteRef: rteRef,
        content: selectedObject.content,
        onChangeHTML: onChangeHTML,
        onChangeProp: onChangeProp,
        fullTextCommandList: fullTextCommandList,
        autoFocusWhenMounted: autoFocusWhenMounted,
        explicitStyleParams: explicitStyleParams,
        elementProps: textEditorElementProps,
        disableLinebreaks: disableLinebreaks
      });
    });
    return _this;
  }
  _createClass(TextTools, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // update the default style with the first font in the list
      var _this$props2 = this.props,
        fontFamilyList = _this$props2.fontFamilyList,
        _this$props2$textEdit = _this$props2.textEditorState,
        defaultStyle = _this$props2$textEdit.defaultStyle,
        updateDefaultStyle = _this$props2$textEdit.updateDefaultStyle,
        updateCurrentStyle = _this$props2$textEdit.updateCurrentStyle;
      if (fontFamilyList.length > 0) {
        updateDefaultStyle(_objectSpread(_objectSpread({}, defaultStyle), {}, {
          fontFamily: fontFamilyList[0].value
        }));
        updateCurrentStyle(_objectSpread(_objectSpread({}, defaultStyle), {}, {
          fontFamily: fontFamilyList[0].value
        }));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        fontFamilyList = _this$props3.fontFamilyList,
        _this$props3$textEdit = _this$props3.textEditorState,
        defaultStyle = _this$props3$textEdit.defaultStyle,
        updateDefaultStyle = _this$props3$textEdit.updateDefaultStyle,
        updateCurrentStyle = _this$props3$textEdit.updateCurrentStyle,
        currentStyle = _this$props3$textEdit.currentStyle,
        resetDefaultStyle = _this$props3$textEdit.resetDefaultStyle,
        selectedObject = _this$props3.selectedObject;
      var editorContent = this.rteRef.current;
      if (fontFamilyList !== prevProps.fontFamilyList && fontFamilyList.length > 0) {
        updateDefaultStyle({
          fontFamily: fontFamilyList[0].value
        });
      }
      // when there is 0 span's in Text field cursor is always shown in default color even when new color is selected from colorPalette.
      // so required to change color of Text field to currentColor

      if (selectedObject.uuid !== prevProps.selectedObject.uuid) {
        var defaultColor = (0, _isObject["default"])(defaultStyle.color.identifier) ? defaultStyle.color.identifier : (0, _String.parseObjectSafe)(defaultStyle.color.identifier);
        var styleParams = (0, _StyleParams.collectStyleParams)(selectedObject.content);
        var isCustom = (0, _String.parseObjectSafe)((0, _get["default"])(styleParams, 'colors[0].identifier')).custom;
        var selectedColor = selectedObject.style.colors.length > 0 ? selectedObject.style.colors[0] : defaultColor;
        var colorId = (0, _String.parseObjectSafe)(selectedColor.identifier).color || selectedColor.identifier;
        var colorObj = {
          value: selectedColor.value || defaultStyle.color.value,
          identifier: {
            color: colorId,
            palette: !isCustom ? defaultColor.palette : null,
            custom: !!isCustom
          }
        };
        if (colorObj.identifier.palette) {
          colorObj.identifier = JSON.stringify(colorObj.identifier);
        }
        updateCurrentStyle({
          color: colorObj,
          fontSize: selectedObject.fontSize
        });
        resetDefaultStyle();
      }
      var colorChanged = currentStyle.color.value !== prevProps.textEditorState.currentStyle.color.value;
      if (colorChanged && editorContent && editorContent.innerText && editorContent.innerText.trim() === '') {
        updateDefaultStyle({
          color: currentStyle.color
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var handleCommand = this.handleCommand,
        renderColorPalette = this.renderColorPalette,
        renderLineTools = this.renderLineTools,
        renderInlineTools = this.renderInlineTools,
        onChangeHTML = this.onChangeHTML,
        onChangeProp = this.onChangeProp,
        rteRef = this.rteRef,
        props = this.props,
        updateCurrentStyle = this.updateCurrentStyle,
        renderTextEditor = this.renderTextEditor;
      var canvas = props.canvas,
        selectedObject = props.selectedObject,
        classes = props.classes,
        fontFamilyList = props.fontFamilyList,
        fontSizeList = props.fontSizeList,
        children = props.children,
        fullTextCommandList = props.fullTextCommandList,
        autoFocusWhenMounted = props.autoFocusWhenMounted,
        textEditorState = props.textEditorState,
        editorRef = props.editorRef;
      if (selectedObject) {
        var renderObj = {
          handleCommand: handleCommand,
          canvas: canvas,
          selectedObject: selectedObject,
          classes: classes,
          renderColorPalette: renderColorPalette,
          renderTextEditor: renderTextEditor,
          onChangeHTML: onChangeHTML,
          onChangeProp: onChangeProp,
          rteRef: rteRef,
          editorRef: editorRef,
          textEditorState: textEditorState,
          updateCurrentStyle: updateCurrentStyle,
          autoFocusWhenMounted: autoFocusWhenMounted,
          components: {
            ToolboxRow: _ToolboxRow["default"],
            ColorPalette: _ColorPalette["default"],
            TextEditor: _TextEditor["default"]
          },
          fontFamilyList: fontFamilyList,
          fontSizeList: fontSizeList,
          fullTextCommandList: fullTextCommandList
        };
        if (typeof children === 'function') {
          return children(renderObj);
        }
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderLineTools(renderObj), renderInlineTools(renderObj), /*#__PURE__*/_react["default"].createElement(_ToolboxRow["default"], null, renderTextEditor(renderObj)));
      }
      return null;
    }
  }]);
  return TextTools;
}(_react["default"].Component);
_defineProperty(TextTools, "propTypes", {
  renderLineTools: _propTypes["default"].func,
  renderInlineTools: _propTypes["default"].func,
  selectedObject: _propTypes["default"].object,
  autoFocusWhenMounted: _propTypes["default"].bool,
  withStateProvider: _propTypes["default"].bool,
  fullTextCommandList: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
  canvas: _propTypes["default"].instanceOf(_Canvas.AbstractCanvas).isRequired,
  fontFamilyList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })).isRequired,
  fontSizeList: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired).isRequired,
  classes: _propTypes["default"].object.isRequired
});
_defineProperty(TextTools, "defaultProps", {
  fontFamilyList: fontFamilyList,
  fontSizeList: fontSizeList,
  autoFocusWhenMounted: true,
  fullTextCommandList: [],
  withStateProvider: false
});
var _default = exports["default"] = (0, _withStyles["default"])(_styles["default"], {
  name: 'Designer-TextTools'
})((0, _TextEditorStateProvider.withTextEditorState)(TextTools));